import type { SearchVehicle } from '../types'

export const consignorStockNumber = ({ consignorStockNumber: _consignorStockNumber }: SearchVehicle): string =>
    _consignorStockNumber || ''
